import { IGetFeaturesResponse } from "../domain/dtos/IGetFeaturesResponse";
import { IPlansService } from "../domain/interfaces/IPlansService";
import { FeatureTypeEnum } from "../presentation/interfaces/FeatureTypeEnum";

export const GetAdditionalFeaturesUseCase = async (service: IPlansService, featureType: FeatureTypeEnum[], page?: number, pageSize?: number): Promise<IGetFeaturesResponse[]> => {
    return service.getAdditionalFeatures(featureType, page || 1, pageSize || 100);
}
